/**
 * Google Analytics event tracking for mega menu navigation clicks.
 * Tracks the navigation hierarchy to understand menu usage patterns.
 *
 * Adapted for the Horizon theme's cpap-header / cpap-mega-menu structure.
 * The CPAP mega menu uses `.menu-item a` links nested within `.sub-menu` lists.
 *
 * Requires: Google Tag Manager / gtag.js to be loaded on the page.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Desktop mega menu links
  var desktopLinks = document.querySelectorAll(
    '.cpap-mega-menu .menu-item a'
  );

  // Mobile drawer menu links (cpap-header mobile menu)
  var mobileLinks = document.querySelectorAll(
    '.mobile-menu .menu-item a, .menu-drawer .menu-item a'
  );

  var allLinks = [...desktopLinks, ...mobileLinks];

  allLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var levelString = getLevel(event.currentTarget);
      sendEvent(levelString);
    });
  });
});

/**
 * Send a Google Analytics event with the menu level hierarchy.
 * @param {string} level - The navigation path string
 */
var sendEvent = function (level) {
  if (typeof gtag === 'function') {
    gtag('event', level, {
      app_name: 'CPAP Online Store',
      page: window.location.pathname,
    });
  }
};

/**
 * Extract the URL slug from a full URL.
 * @param {string} url - The URL to extract the slug from
 * @returns {string|undefined} The slug portion of the URL
 */
var getSlug = function (url) {
  if (!url) return;
  var split = url.split('/');
  var slug = split[split.length - 1];
  slug = slug.replaceAll('#', '');
  return slug;
};

/**
 * Build the navigation level string by traversing the DOM hierarchy.
 * Walks up the DOM tree from the clicked link to find parent menu items
 * and constructs a breadcrumb-style string: "mega_menu > level1 > level2 > level3"
 *
 * @param {HTMLElement} element - The clicked link element
 * @returns {string} The navigation hierarchy string
 */
var getLevel = function (element) {
  var levels = [];
  var current = element;

  // Get the text or slug of the clicked link
  var linkText = getSlug(current.href) || current.textContent.trim();
  if (linkText) {
    levels.unshift(linkText);
  }

  // Walk up the DOM to find parent menu items
  var parent = current.closest('.menu-item');
  if (parent) {
    parent = parent.parentElement;
  }

  while (parent) {
    var menuItem = parent.closest('.menu-item');
    if (!menuItem) break;

    // Look for a heading or direct link text in this parent menu item
    var heading = menuItem.querySelector(':scope > .heading, :scope > a');
    if (heading) {
      var text = getSlug(heading.href) || heading.textContent.trim();
      if (text) {
        levels.unshift(text);
      }
    }

    parent = menuItem.parentElement;
  }

  return 'mega_menu' + (levels.length > 0 ? ' > ' + levels.join(' > ') : '');
};
